import styled from 'styled-components'

export const StyledCards = styled.div`
    display: flex;
    flex-direction: ${({ aaa }) => aaa ? aaa : 'row'};
    margin-left: -2.5px;
    margin-right: -2.5px;
`